import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  ColumnConfig,
  FilterConfig,
  JobPost,
} from '../../../interfaces/job-post';
import { PositionService } from '../services/position.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-position-table',
  templateUrl: './position-table.component.html',
  styleUrls: ['./position-table.component.css'],
})
export class PositionTableComponent implements OnInit {
  jobs: JobPost[] = [];
  loading = false;
  error = '';
  totalElements = 0;
  currentPage = 0;
  serverPage = 1;
activeName     = '';
activeJobLevel = '';
  columns: ColumnConfig[] = [];
  searchQuery = '';
  searchTimeout: any = null;
  filters: FilterConfig[] = [];

  searchKey = 'position';

  constructor(
    private router: Router,
    private positionService: PositionService,
    private translate: TranslateService
  ) {
    this.initTranslations();
  }

  private initTranslations(): void {
    this.columns = [
      { label: 'Position', key: 'position' },
      { label: 'Level', key: 'level' },
      { label: 'Team/Department', key: 'team' },
    ];
    this.filters = [
      {
        label: 'Position',
        key: 'position',
        options: ['UI/UX designer', 'Front-end developer'],
      },
      {
        label: 'Level',
        key: 'level',
        options: ['mid-level', 'senior', 'junior'],
      },
    ];
  }

  ngOnInit(): void {
    this.loadPositions(0);
  }


loadPositions(page: number): void {
  this.loading = true;
  this.error = '';

  const filters = {
    name:     this.activeName     || undefined,
    jobLevel: this.activeJobLevel || undefined,
    search:   this.searchQuery.trim() || undefined,
  };

  this.positionService.getPositions(page, 10, filters).subscribe({
    next: (res: any) => {
      this.mapResponse(res, page);
    },
    error: (err) => {
      console.error('Failed to load positions', err);
      this.error = this.translate.instant('Failed to load positions. Please try again.');
      this.loading = false;
    },
  });
}

private mapResponse(res: any, page: number): void {
  const pageData        = res.positions;
  this.jobs             = pageData.content.map((p: any) => ({
    id:       p.id ?? '',
    position: p.title,
    level:    p.jobLevel,
    team:     p.department,
  }));
  this.totalElements    = pageData.totalElements;
  this.currentPage      = pageData.number;
  this.serverPage       = pageData.number + 1;
  this.generateFilters(res.positionNames ?? []);
  this.loading          = false;
}
generateFilters(positionNames: string[]): void {
  this.filters = [
    {
      label: 'Position',
      key:   'position',
      options: positionNames,
    },
    {
      label: 'Level',
      key:   'level',
      options: ['ENTRY_LEVEL', 'MID_LEVEL', 'SENIOR_LEVEL', 'EXPERIENCED'],
    },
  ];
}

onFilterChanged(filterKey: string, value: string): void {
  const normalized = value === 'All' ? '' : value;
  if (filterKey === 'position') this.activeName     = normalized;
  if (filterKey === 'level')    this.activeJobLevel = normalized;
  this.currentPage = 0;
  this.loadPositions(0);
}

  onPageChanged(page: number): void {
    this.loadPositions(page);
  }

  onPostVacancy(): void {
    this.router.navigate(['/company-admin/add-position']);
  }

  onEdit(job: JobPost): void {
    this.router.navigate(['/company-admin/edit-position', job.id]);
  }

  onDelete(job: JobPost): void {
    if (!confirm(this.translate.instant('Delete position') + ` "${job.position}"?`)) return;
    this.positionService.deletePosition(job.id!).subscribe({
      next: () => {
        this.jobs = this.jobs.filter((j) => j.id !== job.id);
        this.totalElements--;
      },
      error: (err) => {
        console.error('Failed to delete position', err);
        alert(this.translate.instant('Failed to delete position. Please try again.'));
      },
    });
  }
  onSearchChange(value: string): void {
  this.searchQuery = value;
  clearTimeout(this.searchTimeout);
  this.searchTimeout = setTimeout(() => {
    this.currentPage = 0;
    this.loadPositions(0);
  }, 400);
}
}
